import { useState } from "react";
import { Button, Menu, MenuItem } from "@mui/material";

interface BotonMenuProps {
    textButton: string;
    iconButton: any;
    options: Array<{ key: any; value: any }>;
    loading?: boolean;
    handleOnOptionSelect: (item: { key: any; value: any }) => void;
}

export const BotonMenu = (props: BotonMenuProps) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const handleOnClose = () => {
        setAnchorEl(null);
    };

    const handleOnOptionSelected = (option: { key: any; value: any }) => {
        props.handleOnOptionSelect(option);
        handleOnClose();
    };

    return (
        <>
            <Button
                aria-controls="menu-ejeco"
                variant="contained"
                endIcon={props.iconButton}
                onClick={(event) => setAnchorEl(event.currentTarget)}
                loading={props.loading}
            >
                {props.textButton}
            </Button>
            <Menu
                id="menu-ejeco"
                open={Boolean(anchorEl)}
                anchorEl={anchorEl}
                onClose={handleOnClose}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                }}
            >
                {props.options.map((item, idx) => (
                    <MenuItem key={idx} value={item.key} onClick={() => handleOnOptionSelected(item)}>
                        {item.value}
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
};
